import React, { Component } from 'react'
import history from '../../routes/history';
import { 
    AssessmentContainer, 
    AssessmentContentCenteredSection,
    AssessmentBody, 
    AssessmentContent, 
    AssessmentNavigationPrevious, 
    AssessmentNavigationNext, 
    AssessmentContentHeader,
    AssessmentFooter 
} from '../assessment/common';
import { connect } from 'react-redux'
import * as actionCreator from '../../redux/actions/data-action';

class ErrorScreen extends Component {
    componentDidMount() {
        window.history.pushState(null, null, history.location.href);
        window.onpopstate = function(event) {
            history.go(1);
        };
    }

    render() {
        const { dataRequest } = this.props;
        const css = `
            body {
                margin: 0 auto;
                float: none;
                max-width: 1080px;
                font-size: .7em;
                font-family: Roboto, Verdana, Arial, Helvetica;
            }

            fieldset {
                padding: 0 0px 0px px;
            }

            h1 {
                font-size: 62px;
                margin: 0;
                color: #2E4DC9;
                font-family: Roboto, Verdana, Arial, Helvetica;
                text-align: center;
            }

            h2 {
                font-size: 36px;
                margin: 0;
                color: #2E4DC9;
                font-family: Roboto, Verdana, Arial, Helvetica;
                text-align: center;
            }

            h3 {
                font-size: 24px;
                margin: 0px;
                0 0 0;
                top: 246px;
                left: 368px;
                width: 1080px;
                height: 69px;
                color: #2E4DC9;
                font-family: Roboto, Verdana, Arial, Helvetica;
                text-align: center;
            }

            h4 {
                font-size: 12px;
                margin: 0px;
                0 0 0;
                color: #2E4DC9;
                font-family: Roboto, Verdana, Arial, Helvetica;
                text-align: center;
            }

            img {
                display: block;
                margin: 0 auto;
            }

            #header {
                width: 1080px;
                margin: 0 auto;
                padding: 20px 2% 6px 2%;
                font-family: "trebuchet MS", Verdana, sans-serif;
                color: #FFF;
                background-color: #;
                display: block;
            }

            #subtitle {
                width: 1080px;
                height: 69px;
                margin: 0 auto;
                position: relative;
            }

            #image {
                width: 1080px;
                height: 360px;
                margin: 0 auto;
                position: relative;
            }

            #errormessage {
                width: 1080px;
                height: 43px;
                margin: 0 auto;
                position: relative;
            }

            #footer {
                width: 1080px;
                height: 111px;
                margin: 0 auto;
                position: relative;
            }
        `

        return (
            <div>
                <style type="text/css">
                    {css}
                </style>
                <div id="header">
                    <h1>Sorry, something went wrong</h1>
                </div>
                <div id="subtitle">
                    <h2>Please try again in a few minutes.</h2>
                </div>
                <div id="image">
                    <img src="http://a2.mhs.com/MHS_Error_Message_Image.jpg" width="614" height="360" alt="" />
                </div>
                <div id="errormessage">
                    <h4>
                        <label ID="lblError">{dataRequest.errorCode != "" ? dataRequest.errorCode + ": " : ""}{dataRequest.error}</label>
                    </h4>
                </div>
                <div id="footer">
                    <h3>Still seeing this message?</h3>
                    <br/>
                    <h3>Contact Customer Service at <a href="tel:+1-800-456-3003">1-800-456-3003</a></h3>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownState) => ({
    dataRequest: state.dataRequest
})

export default connect(mapStateToProps, actionCreator)(ErrorScreen);